import React from 'react'


const Header = () => {
    return (
         <div className="headers">
                <div className="headers-items">
                        <h1>Welcome to photo booth , share and download images from around the world</h1>
                        <button className="ui right labeled icon button massive inverted">
                                <i className="right arrow icon"></i>
                                Next
                              </button>
                </div>
             </div>
    )
}

export default Header;